import {getFindTeammate} from '../../../../../src/store/data/teammates/lazyTeammatesSelectors';
import {createSelector} from '../../../../helpers/reselectHelpers';
import {getCommentActivity} from './commentViewerSelectors';

/** Find the author for our comment activity. */
export function makeGetAuthorFromCommentActivity() {
  return createSelector([getFindTeammate, getCommentActivity], (findTeammate, activity) => {
    if (!activity.authorId) {
      return undefined;
    }

    return findTeammate(activity.authorId, 'commentTombstoneSelectors makeGetAuthorFromCommentActivity');
  });
}
